import { render, staticRenderFns } from "./TransferSea.vue?vue&type=template&id=612d6e05&"
import script from "./TransferSea.vue?vue&type=script&lang=js&"
export * from "./TransferSea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports